import { IMessageBarProps, MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";

import { Text } from "./Text";

export interface SuccessMessageProps extends Pick<IMessageBarProps, "styles"> {
    message: string;
}

export const SuccessMessage: React.FC<SuccessMessageProps> = ({ message, styles }: SuccessMessageProps) => {
    return (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={true} styles={styles}>
            <Text block={false} nowrap={false} variant="smallPlus">
                {message}
            </Text>
        </MessageBar>
    );
};
